// ============================================================
//  src/admin/portfolio/PortfolioCard.jsx
// ============================================================

import React from "react";

const PortfolioCard = ({ item, onEdit, onDelete }) => {
  const isVideo = item.type === "video";

  // item.image is now always a full URL (fixed in portfolioData.js)
  const thumbSrc = item.image || null;

  const handleDelete = (e) => {
    e.stopPropagation();
    if (window.confirm(`Delete "${item.title}"? This cannot be undone.`)) {
      onDelete(item.id);
    }
  };

  return (
    <div className="pa-card">
      {Number(item.featured) === 1 && (
        <span className="pa-card__badge">
          <svg width="9" height="9" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
          Featured
        </span>
      )}

      <span className={`pa-card__type ${isVideo ? "pa-card__type--video" : ""}`}>
        {isVideo ? (
          <>
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polygon points="5 3 19 12 5 21 5 3" />
            </svg>
            Video
          </>
        ) : (
          <>
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <polyline points="21 15 16 10 5 21" />
            </svg>
            Image
          </>
        )}
      </span>

      {/* Thumbnail */}
      <div className="pa-card__thumb">
        {thumbSrc ? (
          <img
            src={thumbSrc}
            alt={item.title}
            className="pa-card__img"
            onError={(e) => {
              e.target.style.display = "none";
              // Show placeholder sibling
              const placeholder = e.target.parentNode.querySelector(".pa-card__placeholder");
              if (placeholder) placeholder.style.display = "flex";
            }}
          />
        ) : null}

        {/* Fallback placeholder */}
        <div
          className="pa-card__placeholder"
          style={{ display: thumbSrc ? "none" : "flex" }}
        >
          {isVideo ? (
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
              <rect x="2" y="6" width="14" height="13" rx="1" />
              <path d="m16 10 6-3v10l-6-3V10Z" />
            </svg>
          ) : (
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <polyline points="21 15 16 10 5 21" />
            </svg>
          )}
          <span>No Media</span>
        </div>

        <div className="pa-card__overlay">
          <button
            className="pa-card__action pa-card__action--edit"
            onClick={() => onEdit(item)}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
            </svg>
            Edit
          </button>
          <button
            className="pa-card__action pa-card__action--del"
            onClick={handleDelete}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6l-1 14H6L5 6" />
              <path d="M10 11v6M14 11v6" />
              <path d="M9 6V4h6v2" />
            </svg>
            Delete
          </button>
        </div>
      </div>

      <div className="pa-card__info">
        <p className="pa-card__title">{item.title}</p>
        <span className="pa-card__cat">{item.category}</span>
        {item.description && <p className="pa-card__desc">{item.description}</p>}
        <p className="pa-card__date">{item.created_at || item.createdAt}</p>
      </div>
    </div>
  );
};

export default PortfolioCard;